import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { productShortName } from '../data/offer';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-168" data-mp="21yd8ya0c84tx">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-xl border border-slate-600/40 border-l-4 border-l-yellow-400 bg-blue-950 p-4 pr-10 text-stone-50 shadow-2xl shadow-black/50" aria-live="polite" data-id="element-169" data-mp="1wyh3e6bzs5c9">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-slate-300 transition-colors duration-150 ease-out hover:text-stone-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400" aria-label="Dismiss notice" data-id="element-170" data-mp="1sgfnzegxvsb7">
            <XIcon className="h-4 w-4" data-id="element-171" data-mp="1nfi858jejacv" />
          </button>
          <div className="flex gap-3" data-id="element-172" data-mp="19pokgtjmuw4q">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-yellow-400" aria-hidden="true" data-id="element-173" data-mp="19omxbqpcej6n" />
            <div data-id="element-174" data-mp="1egwqrgpo21do">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-yellow-400" data-id="element-175" data-mp="1ehg3mj0glzku">Access confirmed</p>
              <p className="mt-1 text-sm leading-snug text-slate-300" data-id="element-176" data-mp="zpe8fc9c3ur5">
                Once your purchase is complete you receive the
                <br data-id="element-177" data-mp="qqan01mp339h" />
                <span className="font-bold text-stone-50" data-id="element-178" data-mp="qrvf7kljea46">{productShortName}</span>
              </p>
              <p className="mt-2 text-xs text-slate-300" data-id="element-179" data-mp="voc6uory36m0">Instant digital access to the PDF volumes by email.</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}